<template>
	<div class="wrapper rate-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>AP購入価格に関しまして</h1>
					<div class="rate-box">
						<p>
							AP購入価格に関しまして取引所の売り板が薄い場合、実際の購入価格は現レートよりも高くなる場合があります。<br>
							例：現レート1AP = 1.3750USDの場合でも必要購入枚数により、実際の購入価格が平均8～10％以上の差が発生する場合もあります。下図の売り板の場合は約3000枚を購入する場合は1.3898USDまで価格が上がることになります。
						</p>
						<div class="img">
							<img src="../assets/img/rate-img1.png" alt="">
						</div>
						<p>例えば購入枚数が3万枚などになると売り板の表示されていない※1の部分（さらに高いレート）で購入することになります。</p>
						<p>また特に上昇トレンド中での購入時は最低購入価格が徐々に切り上がっていくため、1.3750（赤枠）からの購入ができなくなります。</p>
						<h2>具体的な購入例</h2>
						<p>前提としてAZEROは長期的に見て上昇トレンドにあります。</p>
						<div class="img">
							<img src="../assets/img/rate-img2.png" alt="">
						</div>
						<p>150000USDT分のAZEROを購入する場合</p>
						<p>［指値で購入］<br>
						現レート1.3749ですべて購入できた場合は109099AZEROを取得できます。</p>
						<div class="img">
							<img src="../assets/img/rate-img3.png" alt="">
						</div>
						<p>ただし、実際に1.3749で購入できるのは200枚程度となります。<br>
						そのため、以下のように成り行きで買付を行う必要があります。</p>
						<p>［成り行きで購入］<br>
						上記の指値と同枚数の109099AZEROを成り行きで購入した場合には下記の購入レートが想定されます（売り板が再生成することも想定）。</p>
						<div class="scroll">
							<ul class="list">
								<li>
									<p class="center">1回目</p>
									<p>1.3749～1.3898  3000枚</p>
									<p>1.3899～1.4038  3000枚</p>
									<p>1.4039～1.4179  3000枚</p>
									<p>1.4180～1.4322  3000枚</p>
									<p>1.4323～1.4466  3000枚</p>
									<p>1.4467～1.4612  3000枚</p>
									<p>1.4613～1.4759  3000枚</p>
									<p>1.4760～1.4907  3000枚</p>
									<p>1.4908～1.5057  3000枚</p>
									<p>1.5058～1.5208  3000枚</p>
								</li>
								<li>
									<p class="center">2回目</p>
									<p>1.4180～1.4322  3000枚</p>
									<p>1.4323～1.4466  3000枚</p>
									<p>1.4467～1.4612  3000枚</p>
									<p>1.4613～1.4759  3000枚</p>
									<p>1.4760～1.4907  3000枚</p>
									<p>1.4908～1.5057  3000枚</p>
									<p>1.5058～1.5208  3000枚</p>
									<p>1.5209～1.5361  3000枚</p>
									<p>1.5362～1.5515  3000枚</p>
									<p>1.5516～1.5671  3000枚</p>
								</li>
								<li>
									<p class="center">3回目</p>
									<p>1.4613～1.4759  3000枚</p>
									<p>1.4760～1.4907  3000枚</p>
									<p>1.4908～1.5057  3000枚</p>
									<p>1.5058～1.5208  3000枚</p>
									<p>1.5209～1.5361  3000枚</p>
									<p>1.5362～1.5515  3000枚</p>
									<p>1.5516～1.5671  3000枚</p>
									<p>1.5672～1.5829  3000枚</p>
									<p>1.5830～1.5988  3000枚</p>
									<p>1.5989～1.6149  3000枚</p>
								</li>
								<li>
									<p class="center">4回目</p>
									<p>1.5058～1.5208  3000枚</p>
									<p>1.5209～1.5361  3000枚</p>
									<p>1.5362～1.5515  3000枚</p>
									<p>1.5516～1.5671  3000枚</p>
									<p>1.5672～1.5829  3000枚</p>
									<p>1.5830～1.5988  3000枚</p>
									<p>1.5989～1.6068  1099枚</p>
								</li>
							</ul>
						</div>
						<p>上記の通り1日のうちに最低レートから最高レートで約17%の乖離が生じる場合があります。平均値をとった場合には最低レートから約8％～10%の乖離が想定されます。</p>
						<p>※上記の例はあくまでも参考値となります。<br>
						実際の場合は売り板の厚さにより、レートと枚数は変動するので最低レートから最高レートの乖離幅が拡大することもあります。</p>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="Rate" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Rate",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "Rate",
		};
	},
	methods: {},
	computed: {},
	mounted: function () {},
};
</script>
